import React, { Component } from "react";
import Helmet from "react-helmet";
import Layout from "../layout";
import { Link, graphql, StaticQuery } from "gatsby";
import SeattleWASkylineLight from "../images/sila-life/washington/seattle-wa-line-drawing.svg";
import PostListing from "../components/Post/PostListing";
import BackgroundImage from "gatsby-background-image";
import SeattlePostings from "../components/Lever/SeattlePostings";
import config from "../../data/SiteConfig";

export default () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          silaLife: allFile(
            filter: {
              relativeDirectory: { eq: "sila-life/washington" }
              extension: { ne: "svg" }
            }
          ) {
            edges {
              node {
                name
                childImageSharp {
                  fluid(quality: 100, maxWidth: 640) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }

          seattleVideos: allMarkdownRemark(
            filter: {
              frontmatter: {
                category: { eq: "Video" }
                title: { regex: "/Value/" }
              }
            }
          ) {
            edges {
              node {
                fields {
                  slug
                }
                frontmatter {
                  title
                  youtubeId
                  category
                  tags
                  thumb {
                    childImageSharp {
                      fluid(maxWidth: 350, quality: 100) {
                        ...GatsbyImageSharpFluid_noBase64
                      }
                    }
                    extension
                    publicURL
                  }
                  youtubeId
                }
              }
            }
          }
        }
      `}
      render={data => {
        const silaLifePhotos = data.silaLife.edges.map(silaLifePhoto => {
          return {
            name: silaLifePhoto.node.name,
            fluid: silaLifePhoto.node.childImageSharp.fluid,
            path: silaLifePhoto.node.childImageSharp.fluid.src
          };
        });
        const silaFarmersMarket = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-farmers-market"
        ).path;
        const silaSolarEclipse = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "seattle-team-solar-eclipse"
        ).path;
        const silaCollab = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-office-collaboration"
        ).path;
        const silaPaintNite = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "sila-wa-paint-nite"
        ).path;
        const bookClub = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "book-club"
        ).path;
        const officeYoga = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "office-yoga"
        ).path;
        const soccerGame = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "soccer-game"
        ).path;
        const outdoorScene = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "outdoor-scene"
        ).path;
        const cityBg = silaLifePhotos.find(
          silaLifePhoto => silaLifePhoto.name === "seattle-city-bg"
        ).fluid;
        const postEdges = data.seattleVideos.edges;
        return (
          <Layout>
            <>
              <Helmet
                title={`Sila Life in Seattle, WA | ${config.siteTitle}`}
              />
              <section className="location-graphic-header seattle">
                <img
                  className="location-graphic"
                  alt="The Seattle, Washington skyline"
                  src={SeattleWASkylineLight}
                />
              </section>
              <section className="st-pad-vert">
                <div className="container text-center">
                  <div className="full">
                    <div className="restrict wide">
                      <h1>Sila Life in Seattle, WA</h1>
                      <p>
                        Seattle was recently named the #1 market in the nation
                        for professionals in science, technology, engineering,
                        and mathematics (STEM). Our Seattle consultants are
                        surrounded by top tech companies and like-minded
                        individuals. Not only is our office situated in a
                        buzzing tech city; we're surrounded by the natural
                        beauty just outside of it. After hours, you can find us
                        hiking Mount Si or through the Northern Cascades, taking
                        the ferry over to Bainbridge Island, or strolling around
                        Alki Beach in West Seattle. Browse our{" "}
                        <a href="#openings">Seattle openings</a>.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              <section>
                <h2 className="h3 text-center">We Are Sila Seattle</h2>
                <div className="container make-block">
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaSolarEclipse}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaFarmersMarket}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__one-third"
                    style={{
                      background: `url(${silaCollab}) center center no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                  <div
                    className="culture-collage__two-thirds"
                    style={{
                      background: `url(${silaPaintNite}) center top no-repeat`,
                      backgroundSize: `cover`
                    }}
                  />
                </div>
              </section>

              <h3 className="h2 text-center st-pad-top">A Day in the Life</h3>

              <section className="location-story seattle">
                <section className="st-pad-vert dark-on-light">
                  <div className="container">
                    <div className="story-caption">
                      <h3>Engage your mind</h3>
                      <p>
                        With a focus on continuous learning, we engage with each
                        other through our Communities of Interest and monthly
                        Tech Council and PM Roundtable meetings. Whether you’re
                        reading the latest selection from our Sila Book Club or
                        preparing a presentation for an upcoming Sila U session,
                        there is no shortage of learning opportunities for you.
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="Books selected for the Sila Book Club"
                        src={bookClub}
                      />
                    </div>
                  </div>

                  <div className="cloud-border-top no-marg-bot" />
                </section>

                <section>
                  <div className="container">
                    <div className="story-illustration">
                      <img
                        alt="Mats set up for an in-office yoga session"
                        src={officeYoga}
                      />
                    </div>

                    <div className="story-caption">
                      <h3 className="light-blue-text">Be involved</h3>
                      <p>
                        When not working with our clients, our team gets
                        together throughout the year at hosted events for
                        employees and families alike. From crowd favorites like
                        our Seafair cruise to our annual family picnic and
                        volunteering with Northwest Harvest and Ronald McDonald
                        House, there is sure to be an event for you. Our
                        employees also share their talents by leading us through
                        a weekly yoga session or a mixology happy hour.
                      </p>
                    </div>
                  </div>
                </section>

                <section className="light-on-dark xt-pad-vert">
                  <div className="cloud-border-bottom" />
                  <div className="container">
                    <div className="story-caption">
                      <h3>A job well done</h3>
                      <p>
                        As a consulting firm, we succeed when our clients
                        succeed. But we love to celebrate the accomplishments of
                        our colleagues, too! Acknowledge a job well done and
                        nominate your colleague for a Spot Award. They will win
                        an experience of their choice. Some popular selections
                        are tickets to a Sounders or Seahawks game, a show at
                        the 5th Avenue Theatre, or a concert at Key Arena!
                      </p>
                    </div>

                    <div className="story-illustration">
                      <img
                        alt="Winners of Sila's Spot Award can win tickets to events like the soccer game pictured"
                        src={soccerGame}
                      />
                    </div>
                  </div>
                </section>

                <section className="st-pad-vert no-marg-top light-on-dark">
                  <div className="container">
                    <div className="story-illustration">
                      <img
                        alt="An outdoor scene demonstrating the plentiful natural beauty around Seattle, with camping, hiking, and wildlife"
                        src={outdoorScene}
                      />
                    </div>

                    <div className="story-caption">
                      <h3>On the weekend</h3>
                      <p>
                        When the weekend hits, you'll find our consultants all
                        around the Pacific Northwest! Nature lovers head to the
                        beach or the mountains for a hike. City dwellers explore
                        their favorite Seattle neighborhoods, local restaurants,
                        and farmers markets.
                      </p>
                      <p>
                        We like to enjoy Seattle’s summer months with an annual
                        camping and rafting trip. In the winter, you may find us
                        rock climbing in Ballard or skiing in the Cascades.{" "}
                      </p>
                    </div>
                  </div>
                </section>
              </section>

              <section className="st-pad-vert">
                <div className="container">
                  <div className="full text-center">
                    <h4>
                      Kelly turned a personal passion into an office-wide effort
                      to give back to the commmunity.
                    </h4>
                    <p>
                      See how she did it and how the Sila team rallied around
                      her.
                    </p>
                  </div>
                </div>
                <div className="justify-content-center">
                  <PostListing postEdges={postEdges} />
                </div>
              </section>
              <BackgroundImage
                Tag="section"
                fluid={cityBg}
                className="location-map st-pad-vert seattle-map-bg"
              >
                <div className="container">
                  <div className="restrict wide text-center">
                    <h3>Our Location</h3>
                    <p>
                      We are located at{" "}
                      <a href="https://goo.gl/maps/fzHLQSpNw9z" target="_blank">
                        6840 Fort Dent Way, Suite 375, Seattle, WA 98188
                      </a>
                      .
                    </p>
                    <p>
                      We're near the Starfire sports complex. Go straight at the
                      circle and take a left into our parking lot. Once in the
                      building, take the elevator to the 3rd floor and turn
                      left. You won't miss us through the double glass doors!
                    </p>
                    <div className="responsive-map-embed">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d86307.93242963514!2d-122.31751020130774!3d47.46803467477457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e3!4m0!4m5!1s0x549042d3095ee09d%3A0xaefe9816d6fa408e!2s6840+Fort+Dent+Way+%23375%2C+Tukwila%2C+WA+98188!3m2!1d47.468056!2d-122.2474704!5e0!3m2!1sen!2sus!4v1534274779225"
                        width="600"
                        height="450"
                        frameborder="0"
                        style={{ border: 0 }}
                        allowfullscreen
                      />
                    </div>
                  </div>
                </div>
              </BackgroundImage>
              <section id="openings">
                <div className="container">
                  <div className="full restrict">
                    <h3 className="text-center margin-bottom">
                      Open Positions in Seattle
                    </h3>
                    <SeattlePostings />
                  </div>
                </div>

                <div className="container text-center">
                  <div className="full">
                    <p>
                      If you don't see a role that fits your profile, please{" "}
                      <a
                        href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                        target="_blank"
                      >
                        submit a general application
                      </a>
                      .
                    </p>
                    <p>
                      <a
                        href="https://jobs.lever.co/silasg/a71c995c-f564-4b04-8968-da6702c4d664/apply"
                        target="_blank"
                        className="button primary"
                      >
                        Apply Now
                      </a>
                    </p>
                  </div>
                </div>
              </section>
            </>
          </Layout>
        );
      }}
    />
  );
};
